import React from 'react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Label } from './ui/label';

const ForgotPasswordForm = ({ email, onChange, onSubmit, onBack, loading, error, success }) => (
  <form onSubmit={onSubmit} className="space-y-4">
    <div className="space-y-2">
      <Label htmlFor="email">Email</Label>
      <Input
        id="email"
        name="email"
        type="email"
        placeholder="Enter your email"
        value={email}
        onChange={onChange}
        required
        className="h-11"
      />
    </div>

    {error && (
      <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-600 dark:text-red-400 px-4 py-3 rounded-lg text-sm">
        {error}
      </div>
    )}

    {success && (
      <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 text-green-600 dark:text-green-400 px-4 py-3 rounded-lg text-sm">
        {success}
      </div>
    )}

    <Button
      type="submit"
      className="w-full h-11 bg-blue-600 hover:bg-blue-700 text-white font-medium"
      disabled={loading}
    >
      {loading ? 'Sending...' : 'Send Reset Link'}
    </Button>

    <div className="text-center">
      <Button
        type="button"
        variant="link"
        onClick={onBack}
        className="text-sm text-slate-600 hover:text-slate-700 block w-full"
      >
        Back to sign in
      </Button>
    </div>
  </form>
);

export default ForgotPasswordForm;
